import { FlexColumn, FilledButton } from '@make-software/tg-mini-app-ui';

import { formatHash, WalletButton } from '@/shared';

import { ContentWindow, ButtonWrapper } from './wallet-modal.styled';
import { StyledContentWrapper, Title, StyledHash } from './known-wallet-content.styled';

interface KnownWalletProp {
  telegramName: string;
  connectedWallet: string | null;
  onConnectWallet?: () => void;
  onDisconnectWallet?: () => void;
}

export const KnownWalletContent = ({
  onDisconnectWallet,
  onConnectWallet,
  telegramName,
  connectedWallet
}: KnownWalletProp) => {
  return (
    <StyledContentWrapper>
      <ContentWindow align={'center'} justify={'space-between'}>
        <FlexColumn gap={4}>
          <Title>{telegramName}</Title>
          {connectedWallet && <StyledHash>{formatHash(connectedWallet, 5)}</StyledHash>}
        </FlexColumn>
        <ButtonWrapper>
          <WalletButton isConnected={Boolean(connectedWallet)}>
            {connectedWallet ? 'Connected' : 'Disconnected'}
          </WalletButton>
        </ButtonWrapper>
      </ContentWindow>
      <FilledButton
        title={connectedWallet ? 'Disconnect' : 'Connect'}
        onClick={connectedWallet ? onDisconnectWallet : onConnectWallet}
        borderRadius="0"
      />
    </StyledContentWrapper>
  );
};
